/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {DirtyWildsServerDataParser} from "../DirtyWildsServerDataParser";
import {DirtyWildsGameConfig, IDirtyWildWinRatioConfig} from "../../DirtyWildsGameConfig";


export interface WildSymbolData {
    isNewWild:boolean;
    isDoubleWild:boolean;
    multiplierIndexAfter:number;
    addedSpins:number;
    wildPosition:[number, number];
}


export class DirtyWildsParsedGameData extends SpinParsedGameData {
    get isMultipliedBigWin():boolean {
        return this._isMultipliedBigWin;
    }

    get currentMultipliedWinRatioConfig():IDirtyWildWinRatioConfig | null {
        return this._currentMultipliedWinRatioConfig;
    }

    get currentMultipliedWinRatio():number {
        return this._currentMultipliedWinRatio;
    }

    get isRandomFeatureTriggered():boolean {
        return this._isRandomFeatureTriggered;
    }

    get isRandomSyncFeatureTriggered():boolean{
        return this._isRandomSyncFeatureTriggered;
    }

    get beforeStopSpinsRemaining():number {
        return this._beforeStopSpinsRemaining;
    }

    get positionsWildInfo():WildSymbolData[] {
        return this._positionsWildInfo;
    }

    get afterStopMultiplierIndex():number {
        return this._afterStopMultiplierIndex;
    }

    get afterStopMultiplier():number {
        return this._afterStopMultiplier;
    }

    get afterStopSpinsRemaining():number {
        return this._afterStopSpinsRemaining;
    }

    get totalSpinWinningsMultiplied():number {
        return this._totalSpinWinningsMultiplied;
    }


    public get numberOfRespinPlayed():number {
        return this._numberOfRespinPlayed;
    }

    private _totalSpinWinningsMultiplied:number;
    private _afterStopSpinsRemaining:number;
    private _afterStopMultiplierIndex:number;
    private _afterStopMultiplier:number;
    private _positionsWildInfo:WildSymbolData[];
    private _beforeStopSpinsRemaining:number;
    private _isRandomFeatureTriggered:boolean;
    private _currentMultipliedWinRatio:number;
    private _currentMultipliedWinRatioConfig:IDirtyWildWinRatioConfig | null;
    private _isMultipliedBigWin:boolean;
    private _isRandomSyncFeatureTriggered:boolean;
    private _numberOfRespinPlayed:number;

    constructor(rawData:any, dataParser:DirtyWildsServerDataParser) {
        super(rawData, dataParser);

        this._totalSpinWinningsMultiplied = rawData.totalSpinWinningsMultiplied;

        this._beforeStopSpinsRemaining = rawData.beforeStopSpinsRemaining;

        this._positionsWildInfo = rawData.positionsWildInfo;

        this._afterStopSpinsRemaining = rawData.afterStopSpinsRemaining;
        this._afterStopMultiplierIndex = rawData.afterMultiplierIndex;
        this._afterStopMultiplier = rawData.afterStopMultiplier;

        this._isRandomFeatureTriggered = rawData.isRandomFeatureTriggered;
        this._isRandomSyncFeatureTriggered = rawData.isRandomSyncFeatureTriggered;

        this._currentMultipliedWinRatio = this._totalSpinWinningsMultiplied / this.playedBetValue;

        this._currentMultipliedWinRatioConfig = this.getWinRatioConfig(this._currentMultipliedWinRatio);

        this._isMultipliedBigWin = this._currentMultipliedWinRatio >= DirtyWildsGameConfig.instance.WIN_RATIOS.bigWin[0].ratio;
        this._numberOfRespinPlayed = rawData.numberOfRespinPlayed;
    }

    private getWinRatioConfig(winRatio:number):IDirtyWildWinRatioConfig | null {
        let winLevels:IDirtyWildWinRatioConfig[] = DirtyWildsGameConfig.instance.WIN_RATIOS.normalWin.concat();
        winLevels = winLevels.concat(DirtyWildsGameConfig.instance.WIN_RATIOS.bigWin);

        for(let i:number = winLevels.length - 1; i >= 0; i--) {
            const winLevel = winLevels[i];
            if(winRatio >= winLevel.ratio) {
                return winLevel;
            }
        }
        return null;
    }
}